module.exports = __webpack_public_path__ + "static/media/orderStatus.9f92f738.svg";